/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
var separatorStyles = css({
  background: "var(--ds-border, #0B120E24)",
  height: '1px'
});
export var DropdownSeparator = function DropdownSeparator() {
  return jsx("div", {
    css: separatorStyles
  });
};